<template>
  <div class="component-toast">
    <div
      v-for="(item, index) in toastsReverse"
      :key="item.uuid"
      :class="['toast', item.type]"
    >
      <div v-if="item.icon" class="container-icon">
        <img :src="item.icon" alt="" />
      </div>
      <div class="container-content" v-safe-html="item.content"></div>
      <button v-if="item.actionLabel" type="button" class="toast-action" @click="runAction(item)">{{ item.actionLabel }}</button>
      <div v-if="item.showCloseButton" class="container-button">
        <button type="button" @click="buttonClose($event, item.uuid)">
          <img src="~@/assets/img/ico/ico_delete.svg" alt="" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ComponentToast",
  components: {},
  mixins: [],
  props: [], //components
  data() {
    return {
      toasts: [],
    };
  }, //data
  computed: {
    toastsReverse() {
      return [...this.toasts].reverse();
    },
  }, //methods
  watch: {}, //watch
  created() {
    // Store handlers for cleanup
    this.handleToastAdd = (obj) => {
      this.add(obj);
    };
    this.handleToastRemove = (uuid) => {
      this.remove(uuid);
    };

    this.$eventbus.on("ComponentToast/add", this.handleToastAdd);
    this.$eventbus.on("ComponentToast/remove", this.handleToastRemove);
  }, //created
  mounted() {}, //mounted
  updated() {}, //updated
  unmounted() {
    // Clean up event bus listeners
    if (this.handleToastAdd) {
      this.$eventbus.off("ComponentToast/add", this.handleToastAdd);
    }
    if (this.handleToastRemove) {
      this.$eventbus.off("ComponentToast/remove", this.handleToastRemove);
    }
  }, //computed
  methods: {
    add(obj) {
      const autoHide = obj.autoHide;
      const autoHideDelay = obj.autoHideDelay || 5000;
      const content = obj.content;
      const icon = obj.icon;
      const showCloseButton = obj.showCloseButton;
      const type = obj.type;
      const uuid = this.$helpers.uuidv4();

      this.toasts.push({
        content,
        icon,
        showCloseButton,
        type,
        uuid,
        actionLabel: obj.actionLabel,
        onAction: obj.onAction,
      });

      if (autoHide) {
        setTimeout(() => {
          this.remove(uuid);
        }, autoHideDelay);
      }
    },

    remove(uuid) {
      this.toasts = this.toasts.filter((value) => value.uuid !== uuid);
    },

    //Events

    runAction(item) {
      this.remove(item.uuid);
      if (item.onAction) item.onAction();
    },

    buttonClose(e, uuid) {
      this.remove(uuid);
    },
  }, //unmounted
};
</script>

<style scoped>
.component-toast {
  bottom: 1rem;
  right: 1rem;
  position: fixed;
  max-width: 420px;
  width: calc(100% - 2rem);
  z-index: 10000;
  pointer-events: none;
}

.toast {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75em;

  background-color: #fff;
  border-radius: 12px;
  margin-bottom: 0.75rem;
  padding: 1em 1.25em;
  position: relative;
  pointer-events: all;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.1);

  animation: slideInRight 0.3s cubic-bezier(0.4, 0, 0.2, 1), fadeOut 0.3s cubic-bezier(0.4, 0, 0.2, 1) 4.7s forwards;
  transform-origin: right center;
}

.toast::before {
  content: '';
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  flex-shrink: 0;
  font-weight: bold;
  font-size: 1.1em;
}

.toast.error {
  background-color: #fff;
  border-left: 4px solid #e74c3c;
  color: #333;
}

.toast.error::before {
  content: '✕';
  background: #e74c3c;
  color: white;
}

.toast.success {
  background-color: #fff;
  border-left: 4px solid #27ae60;
  color: #333;
}

.toast.success::before {
  content: '✓';
  background: #27ae60;
  color: white;
}

.toast.warning {
  background-color: #fff;
  border-left: 4px solid #f39c12;
  color: #333;
}

.toast.warning::before {
  content: '⚠';
  background: #f39c12;
  color: white;
  font-size: 0.9em;
}

.container-icon {
  line-height: 100%;
  margin-right: 0.5em;
}

.container-icon img {
  height: 1.2em;
  width: 1.2em;
}

.container-content {
  flex: 1;

  line-height: 100%;
}

.toast-action {
  background: transparent;
  border: none;
  color: #1a8ea8;
  cursor: pointer;
  font-weight: 700;
  font-size: 1em;
  min-height: 44px;
  padding: 0 0.6em;
  margin: -0.6em -0.4em -0.6em 0;
}

.container-button {
  margin-left: auto;
}

.container-button button {
  background-color: transparent;
  border: none;
  line-height: 100%;
  padding: 0.25em;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.container-button button:hover {
  background-color: rgba(0, 0, 0, 0.05);
  transform: rotate(90deg);
}

.container-button button img {
  height: 0.9em;
  opacity: 0.6;
  width: 0.9em;
}

@keyframes slideInRight {
  from {
    transform: translateX(120%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
  to {
    opacity: 0;
    transform: translateX(20px) scale(0.95);
  }
}

@media (max-width: 767px) {
  .container-content {
    flex: 1;

    line-height: 125%;
  }
}

@media (min-width: 768px) {
}

@media (min-width: 992px) {
}

@media (max-width: 1199px) {
}

@media (min-width: 1200px) {
}
</style>
